import { RENDERING_DEFAULTS } from '../../constants/index.js';
export default function setVtkCameraClippingRange(camera) {
    if (camera.getParallelProjection()) {
        camera.setClippingRange(-RENDERING_DEFAULTS.MAXIMUM_RAY_DISTANCE, RENDERING_DEFAULTS.MAXIMUM_RAY_DISTANCE);
        return;
    }
    camera.setClippingRange(RENDERING_DEFAULTS.MINIMUM_SLAB_THICKNESS, RENDERING_DEFAULTS.MAXIMUM_RAY_DISTANCE);
}
